import { DatePipe } from '@angular/common';
import { Component, EventEmitter, Input, Output, SimpleChanges } from '@angular/core';
import moment from 'moment';
import { Subscription } from 'rxjs';
import { DataService, ServicecallService } from 'src/app';
import { EventsServiceService } from 'src/app/modules/events/events-service.service';

@Component({
  selector: 'app-alerts-cases',
  templateUrl: './alerts-cases.component.html',
  styleUrl: './alerts-cases.component.css'
})
export class AlertsCasesComponent {

  @Input() selectedAlert : any;
  alertsMaster: any = [];
  pager: any = {};
  private _alertListSuscription: Subscription;
  private _getAlertsCountSubscription: Subscription;
  private _updateAlertSubscription : Subscription;
  private _getEntityDetailsSubscription: Subscription;
  private _subscription: Subscription;
  columnHeader: any = {};
  pageSize: number = 10;
  currentPage: number = 1;
  @Input() fromDate: number;  
  @Input() toDate:   number;
  @Input() setLabel: string;
  @Input() searchKey: string;
  @Input() filterLists : any;
  @Input() entityId: string;
  @Output() entityName = new EventEmitter<any>();

  //Alert statistics
  activeAlert: number;
  acknowledgedAlert: number;
  alertDetails: { criticalCount: number, majorCount: number, minorCount: number } = {
    criticalCount: null,
    minorCount: null,
    majorCount: null
  };
  alertStateConfig: any;
  selectedState: string = 'total';
  alertFilters: any;
  alertStatus: { name: string; category: string; countValue: string; countBgColor: string; countSelectedBgColor: string; fontColor: string; fontSelectedColor: string; count : number }[];
  alertSeverity: { name: string; category: string; countValue: string; countBgColor: string; countSelectedBgColor: string; fontColor: string; fontSelectedColor: string; count : number }[];
  statusFilter : string;
  severityFilter : string;
  alertAnalyzeDetails: any;
  showAlertAnalyze: boolean = false;
  tenantCategory: string;
  private _entitiesMarkerList: any = [];

  constructor(public _sharedService: ServicecallService, private _service: EventsServiceService, private _datePipe: DatePipe, private _dataSer: DataService,) {
    this._subscription = _dataSer.events.subscribe((res: any) => {
      if (res.name === 'siteChanged' || res.name === 'apiRefresh') {
        this._getAlertData(1);
      } else if (res?.name === 'hideAlertAnalyze' && res?.args[0]?.tab === 'case') {
        this._toggleShowAlertAnalyze(false);
      }
    });
   }

  ngOnInit(): any {
    this.tenantCategory = this._sharedService.getConfiguration('tenantCategory') ? this._sharedService.getConfiguration('tenantCategory').tenantCategory?.category : null;
    this.columnHeader = this._sharedService.getConfiguration('tenantGenericConfig')?.eventsColumnHeader?.['alert'] ? this._sharedService.getConfiguration('tenantGenericConfig')?.eventsColumnHeader?.['alert'] : {};
    this._entitiesMarkerList = this._sharedService.getConfiguration('trackerEntities')?.['trackerEntitiesList'] ?? [];
    this.alertStatus = this._sharedService.getConfiguration('tenantGenericConfig')?.case?.alertCaseStatus ?? [
      {
        "name": "Active",
        "category": "active",
        "countValue": "Count",
        "countBgColor": "#DCE9F0",
        "countSelectedBgColor": "#003983",
        "fontColor": "#003983",
        "fontSelectedColor": "#FFFFFF",
        "count" : null
      },
      {
        "name": "Acknowledged",
        "category": "acknowledged",
        "countValue": "Count",
        "countBgColor": "#E2FAED",
        "countSelectedBgColor": "#4FBB4A",
        "fontColor": "#4FBB4A",
        "fontSelectedColor": "#FFFFFF",
        "count" : null
      }];

    this.alertSeverity = this._sharedService.getConfiguration('tenantGenericConfig')?.case?.alertCaseSeverity ?? [{
      "name": "Critical",
      "category": "critical",
      "countValue": "Count",
      "countBgColor": "#FFF48D6E",
      "countSelectedBgColor": "#F0C506",
      "fontColor": "#F0C506",
      "fontSelectedColor": "#FFFFFF",
      "count" : null
    },
    {
      "name": "Major",
      "category": "major",
      "countValue": "Count",
      "countBgColor": "#E4F4FF",
      "countSelectedBgColor": "#0D99FF",
      "fontColor": "#0D99FF",
      "fontSelectedColor": "#FFFFFF",
      "count" : null
    },
    {
      "name": "Minor",
      "category": "minor",
      "countValue": "Count",
      "countBgColor": "#ECECECBD",
      "countSelectedBgColor": "#8B8B8B",
      "fontColor": "#8B8B8B",
      "fontSelectedColor": "#FFFFFF",
      "count" : null
    }]
  }

  ngOnChanges(changes: SimpleChanges) {
    if (
      changes['fromDate']   ||
      changes['toDate']     ||
      changes['selectedAlert'] || 
      changes['searchKey'] ||
      changes['filterLists'] ||
      changes['entityId']
    ) {
      setTimeout(() => {
        if(this._sharedService.rbacManagement('events_alerts_Alerts_ActiveOrAllAlertsFilter') && !this.fromDate) {
          this.statusFilter = 'active';
        }
        this._getAlertData(1);
      }, 0);
    }
  }

  ngOnDestroy() {
    this._alertListSuscription?.unsubscribe();
    this._getAlertsCountSubscription?.unsubscribe();
    this._updateAlertSubscription?.unsubscribe();
    this._getEntityDetailsSubscription?.unsubscribe();
    this._subscription?.unsubscribe();
  }

  addOrUpdateFilter(
    arr: { type: string; value: string }[],
    newEntries: { type: string; value: string } | { type: string; value: string }[],
    allowMultiple: boolean = false
  ): { type: string; value: string }[] {
    const entries = Array.isArray(newEntries) ? newEntries : [newEntries];
  
    entries.forEach(newEntry => {
      const index = arr.findIndex(item => item.type === newEntry.type);
      if (index !== -1 && !allowMultiple) {
        arr[index] = newEntry; 
      } else {
        arr.push(newEntry); 
      }
    });
    return arr;
  }

  private _getAlertData(pageNo: any) {
    const filterList = [];
    if(this.statusFilter) {
      filterList.push({type: 'Status', value: this.statusFilter});
    }
    if(this.severityFilter) {
      filterList.push({type: 'Severity', value: this.severityFilter});
    }
    if(this.selectedAlert) {
      filterList.push({type: 'Alert', value: this.selectedAlert?.alertDesc});
    }
    this.addOrUpdateFilter(filterList, this.filterLists);
    if(this.filterLists?.find(item => item.type === 'Severity')?.value) {
      this.severityFilter = this.filterLists?.find(item => item.type === 'Severity')?.value;
    }
    this._getAlertsCount();
    const reqData: any = {
      filterBy: 'Alert',
      classType: 'Alert',
      page: pageNo,
      autoClose: null,
      filterList: (this.statusFilter || this.severityFilter || this.selectedAlert ) ? filterList : null,
      entityId: this.entityId,
      zoneId: null,
      // from: this._startDateFromUrl ? this._startDateFromUrl : this._datePipe.transform(this._selectedDates?.from ?? this._startTime, 'yyyy-MM-ddTHH:mm:ssZZ'),
      // to: this._endDateFromUrl ? this._endDateFromUrl : this._datePipe.transform(this._selectedDates?.to ?? new Date(), 'yyyy-MM-ddTHH:mm:ssZZ'),
      siteId: this._sharedService.getSiteId(),
      entityCategory: this._sharedService.getConfiguration('tenantCategory') ? this._sharedService.getConfiguration('tenantCategory').tenantCategory?.category : null,
      limit: this.pageSize,
      ...(this.searchKey && {searchKey: this.searchKey})
    };
    if (this.fromDate != null) {
      const fromStr = this._datePipe.transform(this.fromDate, 'yyyy-MM-ddTHH:mm:ssZZ')!;
      reqData.from = fromStr;
    }
    if (this.toDate != null) {
      const toStr = this.setLabel === 'Yesterday' || this.setLabel === 'Custom'  //Applying current date if date range is not Yesterday/Custom
        ? this._datePipe.transform(new Date(this.toDate)?.setSeconds(new Date()?.getSeconds() + 5), 'yyyy-MM-ddTHH:mm:ssZZ')
        : this._datePipe.transform(new Date()?.setSeconds(new Date()?.getSeconds() + 5), 'yyyy-MM-ddTHH:mm:ssZZ'); //Adding 5 second to capture the state update
      reqData.to = toStr;
    }

    this._alertListSuscription = this._sharedService.alertList(reqData).subscribe((result: any) => {
      if (result['status']) {
        if (result['response'].length) {
          this.alertsMaster = [...result['response']];
          this.alertsMaster.map((item: any) => {
            item.originalTime = item.time;
            item.time = this._sharedService.getLastSeenFormat(item?.time);
            item.status = item.status === true ? 'Active' : 'Acknowledged';
            item.ackBy = item.ackBy ? item.ackBy : "--";
            item.ackTime = item.ackTime !== 'null' ? this._sharedService.getLastSeenFormat(item?.ackTime) : "--";
            item.entityType = 'alerts';
            item.entityModule = this._setEntityType(item.entityCategory);
            item.destination = item.destination ? item.destination : '--';
            item.attributeValue = item.attributeValue ? '' + item.attributeValue : "--";
            item.isSelected = false;
          });
          if (this.entityId) {
            const entityName = result['response'][0]?.entityName;
            this.entityName.emit(entityName);
          }
          // if (this.alertsMaster.length && this.tenantCategory === 'monotainer') {
          //   this.getZoneHistory();
          // }
        }
        else {
          this.alertsMaster = [];
        }
        if (result['pageInfo']) {
          this.pager = { ...result['pageInfo'] };
        }
      } else {
        this.alertsMaster = [];
        this._sharedService.toasterService({ type: 'error', msg: result?.response?.message });
      }
    });

    return this._alertListSuscription;
  }

  private _getAlertsCount(classType?: string) {
    let autoClose;
    if (classType) {
      autoClose = classType === 'null' ? null : classType;
    } else {
      autoClose = 'Alert';
    }
    const filterList = [];
    if(this.selectedAlert) {
      filterList.push({type: 'Alert', value: this.selectedAlert?.alertDesc});
    }
    this.addOrUpdateFilter(filterList, this.filterLists?.filter(item => item.type === 'Alert'));
    if(this.filterLists?.find(item => item.type === 'Severity')?.value) {
      this.severityFilter = this.filterLists?.find(item => item.type === 'Severity')?.value;
    }
    const reqData : any = {
      filterBy: 'Alert',
      classType: 'Alert',
      autoClose: null,
      zoneId: null,
      filterList: this.selectedAlert ? filterList : null,
      entityId: this.entityId,
      // from: this._startDateFromUrl ? this._startDateFromUrl : this._datePipe.transform(this._selectedDates?.from ?? this._startTime, 'yyyy-MM-ddTHH:mm:ssZZ'),
      // to: this._endDateFromUrl ? this._endDateFromUrl : this._datePipe.transform(this._selectedDates?.to ?? new Date(), 'yyyy-MM-ddTHH:mm:ssZZ'),
      siteId: this._sharedService.getSiteId(),
      entityCategory: this._sharedService.getConfiguration('tenantCategory') ? this._sharedService.getConfiguration('tenantCategory').tenantCategory?.category : null,
      status: this.statusFilter ? (this.statusFilter === 'active' ? true : false) : null,
      severity: this.severityFilter ?? null,
      ...(this.searchKey && {searchKey: this.searchKey})
    };

    if (this.fromDate != null) {
      const fromStr = this._datePipe.transform(this.fromDate, 'yyyy-MM-ddTHH:mm:ssZZ')!;
      reqData.from = fromStr;
    }
    if (this.toDate != null) {
      const toStr = this.setLabel === 'Yesterday' || this.setLabel === 'Custom'  //Applying current date if date range is not Yesterday/Custom
        ? this._datePipe.transform(new Date(this.toDate)?.setSeconds(new Date()?.getSeconds() + 5), 'yyyy-MM-ddTHH:mm:ssZZ')
        : this._datePipe.transform(new Date()?.setSeconds(new Date()?.getSeconds() + 5), 'yyyy-MM-ddTHH:mm:ssZZ'); //Adding 5 second to capture the state update
      reqData.to = toStr;
    }
    this._getAlertsCountSubscription = this._sharedService.getAlertsCount(reqData).subscribe((result: any) => {
      if (result['status']) {
        if (result['response']['data']) {
          let alertsCount: any;
          this.alertDetails = {
            criticalCount: null,
            minorCount: null,
            majorCount: null
          };
          const status = result['response']['data'].find((item: any) => item.status)?.status;
          if (status) {
            alertsCount = status.length > 1 ? status[0]?.count + status[1]?.count : status[0]?.count;
            this.activeAlert = status?.find((item1: any) => item1.status === true)?.count;
            this.acknowledgedAlert = status?.find((item1: any) => item1.status === false)?.count;
            this.alertStatus?.forEach(item => {
              if(item.category === 'acknowledged') {
                item.count = this.acknowledgedAlert;
              }
              if(item.category === 'active') {
                item.count = this.activeAlert;
              }
            })
          } else {
            this.activeAlert = null;
            this.acknowledgedAlert = null;
          }
          const severity = result['response'] ? result['response']['data'].find((item: any) => item.severity)?.severity : null;
          if (severity?.length) {
            this.alertDetails.criticalCount = severity?.find((item1: any) => item1.severity == 'critical')?.count ?? this.alertDetails.criticalCount;
            this.alertDetails.minorCount = severity?.find((item1: any) => item1.severity == 'minor')?.count ?? this.alertDetails.minorCount;
            this.alertDetails.majorCount = severity?.find((item1: any) => item1.severity == 'major')?.count ?? this.alertDetails.majorCount;
            this.alertSeverity?.forEach(item => {
              if(item.category === 'major') {
                item.count = this.alertDetails.majorCount;
              }
              if(item.category === 'minor') {
                item.count = this.alertDetails.minorCount;
              }
              if(item.category === 'critical') {
                item.count = this.alertDetails.criticalCount;
              }
            })
          } else {
            this._clearObject();
          }
        } else {
          this._clearObject();
          this.activeAlert = null;
          this.acknowledgedAlert = null;
        }
      }
      else {
        this._clearObject();
        this._sharedService.toasterService({ type: 'error', msg: result?.response?.message });
      }
    })
  }

  /**
   * Sets entity type
   * @param category 
   * @returns  
   */
   private _setEntityType(category: any) {
    const filteredEntityEntityModule = this._entitiesMarkerList?.find((entity: any) => entity.entityCategory === category);
    return filteredEntityEntityModule ? this._setRoute(+filteredEntityEntityModule.entityModule) : '';
  }

  /**
   * Sets route
   * @param entityModule 
   * @returns  
   */
  private _setRoute(entityModule: number) {
    switch (entityModule) {
      case 1: return 'vehicles';
      case 2: return 'assets';
      case 3: return 'people';
      default: return 'assets';
    }
  }

  onPaginateChange(page: any) {
    this.currentPage = page;
    document.getElementById("launchScroll")?.scrollIntoView({ behavior: "smooth" });
    this._getAlertData(this.currentPage);
  }

  tableAction(actionType: any) {
    const { type, item } = actionType;
    if (type === 'export') {
      const fields = Object.entries(this.columnHeader)?.map(([key, value]) => {
          if (key === 'action') return undefined;
          const label = typeof value === 'string' ? value
            : (value && typeof value === 'object' && 'name' in value)
              ? (value as any)?.name
              : '';
          const field: any = { label, value: key };
          if (key === 'time' || key === 'ackTime') {
            field['type'] = 'time';
          }
          return field;
        })
        .filter(Boolean);

      const filterList = [];
      if(this.statusFilter) {
        filterList.push({type: 'Status', value: this.statusFilter});
      }
      if(this.severityFilter) {
        filterList.push({type: 'Severity', value: this.severityFilter});
      }
      if(this.selectedAlert) {
        filterList.push({type: 'Alert', value: this.selectedAlert?.alertDesc});
      }
      const req : any = {
        entityCategory: this.tenantCategory,
        siteId: this._sharedService.getSiteId(),
        autoClose: null,
        entityId: null,
        zoneId: null,
        // from: this._startDateFromUrl ? this._startDateFromUrl : this._datePipe.transform(this._selectedDates?.from ?? this._startTime, 'yyyy-MM-ddTHH:mm:ssZZ'),
        // to: this._endDateFromUrl ? this._endDateFromUrl : this._datePipe.transform(this._selectedDates?.to ?? new Date(), 'yyyy-MM-ddTHH:mm:ssZZ'),
        classType: 'Alert',
        timezone: sessionStorage.getItem('selectedTimeZone') ? sessionStorage.getItem('selectedTimeZone') : moment.tz.guess(),
        exportFormat: item,
        exportFilename: "Alerts",
        fields: [...fields],
        ...(this.statusFilter && {status : this.statusFilter === 'active' ? true : false}),
        ...(this.severityFilter && {severity : this.severityFilter}),
        ...(this.selectedAlert && {alert : this.selectedAlert?.alertDesc})
      }
      if (this.fromDate != null && this.toDate != null) {
        const fromStr = this._datePipe.transform(this.fromDate, 'yyyy-MM-ddTHH:mm:ssZZ')!;
        const toStr   = this.setLabel === 'Yesterday' || this.setLabel === 'Custom'  //Applying current date if date range is not Yesterday/Custom
          ? this._datePipe.transform(new Date(this.toDate)?.setSeconds(new Date()?.getSeconds() + 5),   'yyyy-MM-ddTHH:mm:ssZZ') 
          : this._datePipe.transform(new Date()?.setSeconds(new Date()?.getSeconds() + 5), 'yyyy-MM-ddTHH:mm:ssZZ'); //Adding 5 second to capture the state update
        
          req.from = fromStr;
          req.to = toStr;
      }
      this._sharedService.commonExport(item, req, 'alertsExport', 'Export_Alert_')
    }

    else if (type === "createIncident") {
      const reqData = {
        "alertId": +item?.alertId,
        "incidentParams": {
          "short_description": `${item?.entityName} ${item?.entityCategory} - ${item?.alert}`,
          "comments": "This is a incident created from iDEC",
          "urgency": "3",
          "state": "1",
          "caller_id": "167def90971031101889f5b3f153afaf"
        }
      };
      this._sharedService.createServiceTicket(reqData).subscribe({
        next: (data: any) => {
          if (data && data?.incidentNumber) {
            this._sharedService.toasterService({ type: 'success', msg: `${data?.incidentNumber} - Incident created successfully` });
          } else {
            this._sharedService.toasterService({ type: 'error', msg: `Unable to create a incident` });
          }
        }, error: (error: any) => {
          this._sharedService.toasterService({ type: 'error', msg: `Unable to create a incident` });
        }
      });
      return;
    } else if (type === "downloadCase") {
      this.getEntityDetail(actionType?.item);
    } else if (type === "eventsDrilldown") {
      this.alertAnalyzeDetails = actionType?.item;
      this._toggleShowAlertAnalyze(true);
    } else {
      const reqData = {
        status: false,
        id: actionType.item.id,
        state: actionType?.type !== 'actionTaken' ? actionType?.type : null
      }
      this._updateAlertSubscription = this._service.updateAlert(reqData).subscribe((result: any) => {
        if (result['status']) {
          this._sharedService.toasterService({ type: 'success', msg: result["response"] });
          this._getAlertData(this.currentPage);
        }
      })
    }
  }

  private getEntityDetail(entity: any) {
    this._getEntityDetailsSubscription = this._sharedService.getEntityDetails({ entityId: entity?.entityId }).subscribe((result: any) => {
      if (result.status) {
        const entitydata = result?.response?.data[0];
        this.activeEntityExport(entitydata, entity);

      } else {
        this._sharedService.toasterService({ type: 'error', msg: result?.response?.message });
      }
    });
  }

  activeEntityExport(entityData: any, selectedEntity: any) {
    const startDate = this.getDate5DaysBehind(selectedEntity?.originalTime);
    const endDate = new Date(selectedEntity?.originalTime);
    const reqParam = {
      from: this._datePipe.transform(startDate, 'yyyy-MM-ddTHH:mm:ssZZ'),
      to: this._datePipe.transform(endDate, 'yyyy-MM-ddTHH:mm:ssZZ'),
      entityId: selectedEntity?._id,
      exportFormat: 'csv',
      timezone: sessionStorage.getItem('selectedTimeZone') ? sessionStorage.getItem('selectedTimeZone') : moment.tz.guess(),
      exportFilename: 'Telematics History',
      fields: this._sharedService.getConfigurationBasedOnCategory(entityData, 'export') ?
        this._sharedService.getConfigurationBasedOnCategory(entityData, 'export')?.export?.telematicsHistory : []
    }
    this._sharedService.commonExport(selectedEntity, reqParam, 'activeEntityExport', 'Export_Telematics_History_')
  }

  getDate5DaysBehind(providedDate: string) {
    const date = new Date(providedDate);
    date.setDate(date.getDate() - 5);
    return date;
  }

  private _toggleShowAlertAnalyze(showFlag: boolean) {
    this.showAlertAnalyze = showFlag;
    this._getAlertData(1);
  }

  onPageSizeChange(newSize: number) {
    this.pageSize = newSize; // Update pageSize based on user selection
    this._getAlertData(1); // Fetch data again with the new page size
  }

  private _clearObject() {
    this.alertDetails.criticalCount = null;
    this.alertDetails.minorCount = null;
    this.alertDetails.majorCount = null;
    this.alertStatus?.map(item => item.count = 0);
    this.alertSeverity?.map(item => item.count = 0);
  }

  handleStatusClick(state: string) {
    this.severityFilter = null;
    this.statusFilter = this.statusFilter !== state ? state : null;
    this.filterLists = [];
    this._getAlertData(1);
  }

  handleSeverityClick(state: string) {
    this.statusFilter = null;
    this.severityFilter = this.severityFilter !== state ? state : null;
    this.filterLists = [];
    this._getAlertData(1);
  }

}
